
import { defineComponent } from "vue"
import RunGiftRecordsIndex from "@/components/run_gift_records/Index.vue"

export default defineComponent({
  components: {
    RunGiftRecordsIndex
  }
})
